import { useCallback } from 'react';
import React from 'react';
import { useWindowManager } from '../components/Window/WindowManager';
import { IframePreviewWindow } from '../components/IframePreviewModal';

export const useIframePreviewHandler = () => {
    const windowManager = useWindowManager();

    const openIframePreview = useCallback(({ url, title }: { url: string; title?: string }) => {
        let windowId: string;
        const Component = () => (
            <IframePreviewWindow
                url={url}
                triggerClose={() => windowManager.closeWindow(windowId)}
            />
        );
        windowId = windowManager.openWindow({
            title: title || 'Preview',
            component: Component,
            size: { width: window.innerWidth - 40, height: window.innerHeight - 100 },
            loading: false,
            data: null,
        });
    }, [windowManager]);

    return { openIframePreview };
};
